import { render, staticRenderFns } from "./ModalImportacao.vue?vue&type=template&id=08c85f6c&scoped=true&"
import script from "./ModalImportacao.vue?vue&type=script&lang=js&"
export * from "./ModalImportacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalImportacao.vue?vue&type=style&index=0&id=08c85f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c85f6c",
  null
  
)

export default component.exports